<template>
  <div>
    <div
      v-if="!loadingCharges && !loadingSetting"
      class="message"
      style="float:left;position:relative;border-radius: 12px;max-width: 181px;overflow-wrap: break-word;min-height: 22px;min-width: 14px;line-height:15.36px;overflow: hidden;margin-bottom: 5px;"
    >
      <div style="font-size: 12px;" :style="{ color: 'black' }">
        <div style="padding: 5px 8px 6px;" :style="{ 'background-color': '#F1F0F0' }">
          <span style="line-height:15.36px;">
            <template v-if="currentLang == 'th'">
              === สรุปการสั่งซื้อ ===
              <br />
              <br />
              Shirt (L): 100 {{ $t('Baht') }} <br />-----------------------------
              <br />
              💰ค่าสินค้า (ไม่รวมค่าส่ง) 100 {{ $t('Baht') }} <br />-----------------------------
              <br />
            </template>
            <template v-else-if="currentLang == 'la'">
              === ສະຫຼຸບການສັ່ງຊື້ ===
              <br />
              <br />
              Shirt (L): 100 {{ $t('Baht') }} <br />-----------------------------
              <br />
              💰ຄ່າສິນຄ້າ (ບໍ່ລວມຄ່າຂົນສົ່ງ) 100 {{ $t('Baht') }}
              <br />-----------------------------
              <br />
            </template>
            <template v-else>
              === Order Summary ===
              <br />
              <br />
              Shirt (L): 100 {{ $t('Baht') }} <br />-----------------------------
              <br />
              💰Total (not including shipping) 100 {{ $t('Baht') }}
              <br />-----------------------------
              <br />
            </template>
            {{ $t('Shipping option') }}
            <br />
            <template v-for="(charge, cindex) in charges">
              <div v-if="charge[1]" :key="cindex">
                📦{{ $t(cindex) }}
                <template v-if="charge[0] > 0"
                  >+{{ charge[0] | decimalFormat }} {{ $t('Baht') }}</template
                >
                <template v-else>{{ $t('Free') }}</template>
              </div>
            </template>
          </span>
        </div>
      </div>
      <div
        style="float:left;width: 100%;border: 1px solid #eee; border-bottom-right-radius: 12px;border-bottom-left-radius: 12px;overflow: hidden"
      >
        <ul class="list-group list-group-flush" style="margin-bottom: 0px;">
          <li
            class="list-group-item"
            style="border:none; border-top:1px solid #eee;border-radius: 0px;text-align: center;padding: 10px 15px"
          >
            <span style="color: #0084FF">{{ $t('addmore') }}</span>
          </li>
          <li
            class="list-group-item"
            v-if="showTransfer"
            style="border:none; border-top:1px solid #eee;border-radius: 0px;text-align: center;padding: 10px 15px;border-top:1px solid #eee;"
          >
            <span style="color: #0084FF">{{ $t('banktransfer') }}</span>
          </li>
          <li
            class="list-group-item"
            v-if="showCredicard"
            style="border:none; border-top:1px solid #eee;border-radius: 0px;text-align: center;padding: 10px 15px;border-top:1px solid #eee;"
          >
            <span style="color: #0084FF" v-if="currentLang == 'th'">บัตรเครดิต</span>
            <span style="color: #0084FF" v-else-if="currentLang == 'la'">ບັດເຄດິດ</span>
            <span style="color: #0084FF" v-else>Credit Card</span>
          </li>
        </ul>
      </div>
    </div>
    <div class="clearfix"></div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  computed: {
    ...mapGetters({
      setting: 'setting',
      loadingSetting: 'getLoadingSetting',
      currentLang: 'currentLang',
      loadingCharges: 'getLoadingCharges',
      charges: 'getCharges'
    }),
    showTransfer: function() {
      return this.loadingSetting
        ? false
        : this.setting['allowtransfer'] && this.setting['allowtransfer'].contentvalue
    },
    showCredicard: function() {
      return this.loadingSetting
        ? false
        : this.setting['allowcreditcard'] && this.setting['allowcreditcard'].contentvalue
    }
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/elements/ViewCartSummaryViewer.vue